import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import { api } from '../../context/AuthContext';
import { fuellen } from '../QuickReplies';

// Antwortbausteine als Ein-Klick-Leiste über dem Eingabefeld
export const Schnellantworten = ({ onInsert, platzhalter }) => {
  const [items, setItems] = useState([]);
  const [alle, setAlle] = useState(false);
  useEffect(() => {
    const load = () => api.get('/textbausteine').then((r) => setItems(r.data.items || [])).catch(() => {});
    load();
    window.addEventListener('textbausteine-geaendert', load);
    return () => window.removeEventListener('textbausteine-geaendert', load);
  }, []);
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-2" data-testid="schnellantworten">
      <Zap className="w-3.5 h-3.5 shrink-0 text-[#b8893d]" aria-label="Schnellantworten" />
      {(alle ? items : items.slice(0, 4)).map((b) => (
        <button key={b.id} type="button" onClick={() => onInsert(fuellen(b.text, platzhalter))} title={b.text} data-testid={`schnellantwort-${b.id}`}
          className="shrink-0 h-7 px-3 rounded-full border border-[#DCE3EA] bg-white text-[11px] text-[#1B3A5C] hover:border-[#b8893d] hover:bg-[#fbf7f0] transition-colors">
          {b.titel}
        </button>
      ))}
      {items.length > 4 && <button type="button" onClick={() => setAlle((x) => !x)} data-testid="schnellantworten-mehr" className="shrink-0 h-7 px-2.5 rounded-full text-[11px] text-[#b8893d] hover:text-[#1B3A5C]">{alle ? 'weniger' : `+${items.length - 4} mehr`}</button>}
    </div>
  );
};

export default Schnellantworten;
